import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { OpenAPI as DeprecatedApi } from './openapi/requests';
import { OpenAPI as BackendApi } from './backendapi/requests';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import { ConfigProvider } from './contexts/ConfigContext';
import ReactGA from "react-ga4"
import { DialogProvider } from './contexts/DialogContext';
import { BASE_PATH } from './Environment';

ReactGA.initialize("G-X3J1VP9Z8L");

DeprecatedApi.BASE = BASE_PATH;
BackendApi.BASE = BASE_PATH;

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DialogProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <ConfigProvider>
              <App />
            </ConfigProvider>
          </AuthProvider>
        </BrowserRouter>
      </DialogProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
